<template>
    <v-btn 
        slot="activator" 
        color="primary" 
        class="mb-2"
        fab 
        outlined 
        small
        :to="pathPrintPage"
        target="_blank"
        >
        <v-icon dark>mdi-printer</v-icon>
    </v-btn>
</template>

<script>
import moment from '@/config/moment'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('registers')

export default {
    name: 'PrintBtn',
    props: {
        scope: String,
        subScope: String
    },
    computed: {
        ...mapGetters(['diagnosisById', 'planningById', 'planningGoalById', 'log']),

        pathPrintPage() {
            let path = ''
            switch (this.subScope) {
                case 'swot':
                    path = `/print/swot/${this.planningById._id}`
                    break;
                case 'goals':
                    path = `/print/goals/${this.planningById._id}`
                    break;
            }

            return path
        },                    
    },
}
</script>

<style>

</style>
